import { API_AUTH } from "../../common";

const ConfigPhiKhacApi = {
  getList: (kieuPhiKhac) => API_AUTH.get(`api/configphikhac/${kieuPhiKhac}`),
  addOrUpdate: (data) => API_AUTH.post("api/configphikhac/addorupdate", data),
  changeStatus: (id) => API_AUTH.put(`api/configphikhac/changestatus/${id}`),
  delete: (id) => API_AUTH.delete(`api/configphikhac/${id}`),
};

export default ConfigPhiKhacApi;